import {
  doc,
  getDoc,
  setDoc,
  serverTimestamp,
} from 'firebase/firestore';
import { db } from './firebase';

// Club-wide default start/finish line, stored alongside the course-grid config
// under the club's course_config collection. This makes the default line an
// INDEPENDENT, club-wide setting (Chris, ra-npo7 #4) rather than something that
// only rides along with a season draft. The season bundle still bakes a copy at
// publish time so the app keeps reading defaults from the bundle.
const DEFAULTS_DOC = 'line_defaults';

// The exact set of fields that constitute the default line. Kept explicit so a
// stray field never leaks into the club doc.
const LINE_DEFAULT_FIELDS = [
  'defaultStartType',
  'defaultStartOffsetNm',
  'defaultStartOffsetAngle',
  'defaultStartMarkA',
  'defaultStartMarkB',
  'defaultFinishType',
  'defaultFinishOffsetNm',
  'defaultFinishOffsetAngle',
  'defaultFinishMarkA',
  'defaultFinishMarkB',
];

function defaultsRef(clubId) {
  return doc(db, 'clubs', clubId, 'course_config', DEFAULTS_DOC);
}

/** Pick only the recognised default-line fields from an object. */
export function pickLineDefaults(obj) {
  const out = {};
  for (const k of LINE_DEFAULT_FIELDS) {
    if (obj?.[k] !== undefined) out[k] = obj[k];
  }
  return out;
}

/**
 * Load a club's default start/finish line. Returns null when the club has none
 * saved (caller then falls back to the season bundle / built-in defaults), and
 * returns null rather than throwing on a denied read or malformed doc — this is
 * awaited during the Course Cards initial load and must never break it.
 */
export async function loadClubLineDefaults(clubId) {
  try {
    const snap = await getDoc(defaultsRef(clubId));
    if (!snap.exists()) return null;
    return pickLineDefaults(snap.data());
  } catch {
    return null;
  }
}

/** Persist a club's default start/finish line (independent of any season draft). */
export async function saveClubLineDefaults(clubId, defaults) {
  await setDoc(defaultsRef(clubId), {
    ...pickLineDefaults(defaults),
    updated_at: serverTimestamp(),
  });
}
